// extracted by mini-css-extract-plugin
export default {"container":"ShortcutTooltip-module__container--zYSOz","shortcut":"ShortcutTooltip-module__shortcut--vdfWC","animatedBackground":"ShortcutTooltip-module__animatedBackground--m62H4"};